/*
  Custom validation rules for order form
*/

import { getInvestorCategory, getPlaceList, getCountries, getDeliveryModes } from '../../helpr/orderFormData';
import { required, numeric, requiredIfFieldIs, requiredIfFieldContains, defaultStrMaxLength, alphaCharacters, alphaNumeric, minMaxLengthString } from '../../helpr/generic-validation-rules';

/*
  Check if the string is a member of the option list.
  Use key to map field to orderFormData (Order model specific validation).
*/
export const optionsMember = (string, key) => {
  string = string.trim();
  switch(key) {
    case 'investorCategory': {
      return !(getInvestorCategory().some(cls => cls.value.trim() === string));
    }
    case 'placeOfResidence': {
      return !(getPlaceList().some(cls => cls.value.trim() === string));
    }
    case 'countries': {
      return !(getCountries().some(cls => cls.value.trim() === string));
    }
    case 'deliveryMode': {
      return !(getDeliveryModes().some(cls => cls.value.trim() === string));
    }
  }
}


